/*
 * View containg the response editor.
 * We need to include ckeditorJquery so that we can load the CKEditor, even though we don't
 * use the reference directly
 */

define(["marionette", "./template/topicResponseEditorModalTemplate.html"], function (
  Marionette,
  TopicResponseEditorModalTemplate,
) {
  const TopicResponseEditorModalView = {};

  TopicResponseEditorModalView.topicResponseEditorModalView = Marionette.Layout.extend({
    template: TopicResponseEditorModalTemplate,
    regions: {
      htmlEditor: ".html-editor",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
    disableDoneButton: function () {
      this.$el.find("#doneButton").prop("disabled", true);
    },
    enableDoneButton: function () {
      this.$el.find("#doneButton").prop("disabled", false);
    },
    disableCancelButton: function () {
      this.$el.find("#cancelButton").prop("disabled", true);
    },
    enableCancelButton: function () {
      this.$el.find("#cancelButton").prop("disabled", false);
    },
  });

  return TopicResponseEditorModalView;
});
